





import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import { CarouselContent, ProductRenderStyle } from '~/features/home';
export default defineComponent({
  name: 'ProductCarouselFragment',
  props: {
    content: {
      type: Object as PropType<CarouselContent[]>,
      default: () => {},
    },
    componentStyle: {
      type: Number as PropType<ProductRenderStyle>,
      default: ProductRenderStyle.DEFAULT,
    },
  },
  setup(props) {
    return {
      type: computed(() => {
        return props.componentStyle === ProductRenderStyle.INVERTED ? 'inverted' : 'default';
      }),
    };
  },
});
